import { render, staticRenderFns } from "./FailedNotification.vue?vue&type=template&id=45839f41&scoped=true&"
import script from "./FailedNotification.vue?vue&type=script&lang=js&"
export * from "./FailedNotification.vue?vue&type=script&lang=js&"
import style0 from "./FailedNotification.vue?vue&type=style&index=0&id=45839f41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45839f41",
  null
  
)

export default component.exports